import { createUseStyles } from 'react-jss'
import { trafficGreenDark, mediumGrey, trafficRedDark } from '../../../../styles/const/colors'
import { defaultBorderRadius } from '../../../../styles/const/common'

const getHeaderColor = color => {
  switch (color) {
    case 'success':
      return trafficGreenDark
    default:
      return trafficRedDark
  }
}

const getContainerBorderColor = borderColor => {
  switch (borderColor) {
    case 'success':
      return trafficGreenDark
    case 'warning':
      return trafficRedDark
    default:
      return mediumGrey
  }
}

const useStyles = createUseStyles({
  container: {
    marginTop: 16,
    padding: 10,
    border: ({ borderColor }) => `1px solid ${getContainerBorderColor(borderColor)}`,
    borderRadius: defaultBorderRadius
  },
  icon: {
    fill: ({ color }) => getHeaderColor(color)
  },
  headerWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  header: {
    color: ({ color }) => getHeaderColor(color),
    fontSize: 12,
    marginLeft: 9,
    textTransform: 'uppercase'
  },
  warningText: {
    color: mediumGrey,
    fontSize: 12,
    marginTop: 9,
    '& a': {
      color: mediumGrey
    }
  }
})

export default useStyles
